import { faBookDead } from "@fortawesome/pro-regular-svg-icons/faBookDead";
import { faImage } from "@fortawesome/pro-regular-svg-icons/faImage";
import { faText } from "@fortawesome/pro-regular-svg-icons/faText";
import { faVideo } from "@fortawesome/pro-regular-svg-icons/faVideo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CardActions, Grid, Typography } from "@mui/material";
import { StyledComponentProps } from "@mui/styles";
import * as api from "api/Knowledge";
import { FeedClassKey } from "assets/jss/common-styles";
import BoxDrawer from "components/BoxDrawer";
import ButtonApproval from "components/Buttons/ButtonApproval";
import ButtonExpander from "components/Buttons/ButtonExpander";
import ButtonReproval from "components/Buttons/ButtonReproval";
import { SpinnerIndicator } from "components/CallServer";
import MuiRegularButton from "components/MuiExtras/Button/MuiRegularButton";
import MuiMessageBox from "components/MuiExtras/MessageBox/MuiMessageBox";
import MuiBox from "components/MuiExtras/MuiBox";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiPaper from "components/MuiExtras/MuiPaper";
import MuiPushRight from "components/MuiExtras/MuiPushRight";
import MuiWell from "components/MuiExtras/MuiWell";
import TextFieldCounter from "components/TextFieldCounter";
import PublicationCognitiveAnalysisReasonName from "components/Translations/PublicationCognitiveAnalysisReasonName";
import { FeedType, PublicationCognitiveAnalysisReason } from "models/ApiEnums";
import { FeedItemDto } from "models/ApiModels";
import * as React from "react";
import { Trans, useTranslation, WithTranslation, withTranslation } from "react-i18next";
import { ActionOtherRequesterBody, ActionRequesterBody } from "views/Timeline/Components/CardComp/ActionBody";
import ActionsDefaultDropDown from "views/Timeline/Components/CardComp/ActionsDefaultDropDown";
import ActionsDefaultRight from "views/Timeline/Components/CardComp/ActionsDefaultRight";
import ActionsPollDropDown from "views/Timeline/Components/CardComp/ActionsPollDropDown";
import ActionsSocial from "views/Timeline/Components/CardComp/ActionsSocial";
import ApprovalButtons from "views/Timeline/Components/CardComp/ApprovalButtons";

/////////////////////////////////////////////////////////////////////////////////////

interface IRenderDenouncementsProps {
    item: FeedItemDto;
}

export const RenderDenouncements: React.FC<IRenderDenouncementsProps & StyledComponentProps<FeedClassKey>> = (props) => {

    const {
        classes,
        item,
    } = props;

    return (
        <>
            <MuiContainer margin="dense">
                <ActionRequesterBody
                    classes={classes}
                    data={item}
                />
            </MuiContainer>

            {
                item.action.otherReports == null
                    ? null
                    : item.action.otherReports.map((v) => {
                        return (
                            <MuiContainer margin="dense">
                                <ActionOtherRequesterBody
                                    key={v.requester.id}
                                    classes={classes}
                                    data={v}
                                />
                            </MuiContainer>
                        );
                    })
            }
        </>
    );
};

/////////////////////////////////////////////////////////////////////////////////////

export const RenderAutoModerationReason: React.FC<IRenderDenouncementsProps & StyledComponentProps<FeedClassKey>> = (props) => {
    const { t } = useTranslation();

    const {
        item,
    } = props;

    const reasons: React.ReactNode[] = [];

    if (item.publication.contentCognitiveAnalysisReasons != null) {
        Object.keys(PublicationCognitiveAnalysisReason).forEach((v) => {
            var k = parseInt(v);
            if ((item.publication.contentCognitiveAnalysisReasons & k) > 0)
                reasons.push(
                    <React.Fragment key={"contentCognitiveAnalysisReasons_" + k}>
                        <FontAwesomeIcon fixedWidth icon={faText} />
                        <PublicationCognitiveAnalysisReasonName value={k as PublicationCognitiveAnalysisReason} />
                    </React.Fragment>
                );
        });
    }

    if (item.publication.contentCognitiveAnalysisWords != null && item.publication.contentCognitiveAnalysisWords.length > 0) {
        reasons.push(
            <React.Fragment key="contentCognitiveAnalysisWords">
                <FontAwesomeIcon fixedWidth icon={faBookDead} />
                <span>{t("Common.Feed.Approval.AutoModerationWordsSuspicious")}: <b>{item.publication.contentCognitiveAnalysisWords}</b></span>
            </React.Fragment>
        );
    }

    const oneType: number[] = [];
    item.publication.attachsCognitiveAnalysis.forEach((a) => {
        Object.keys(PublicationCognitiveAnalysisReason).forEach((v) => {
            var k = parseInt(v);
            if ((a.cognitiveAnalysisReasons & k) > 0) {
                if (oneType.indexOf(k) == -1) {
                    oneType.push(k);
                    reasons.push(
                        <React.Fragment key={"attachsCognitiveAnalysis_" + k}>
                            <FontAwesomeIcon fixedWidth icon={a.fileMimeType.indexOf("image") > -1 ? faImage : faVideo} />
                            <PublicationCognitiveAnalysisReasonName value={k as PublicationCognitiveAnalysisReason} />
                        </React.Fragment>
                    );
                }
            }
        });
    });

    return reasons.length == 0
        ? null
        : (
            <>
                <MuiContainer margin="dense">
                    <MuiBox variant="warning">
                        <Typography variant="button">{t("Common.Feed.Approval.AutoModerationTitle")}:</Typography>
                        <ul>
                            {reasons.map((v, index) => <li key={index}><Typography variant="body2">{v}</Typography></li>)}
                        </ul>
                    </MuiBox>
                </MuiContainer>
            </>
        );
};

/////////////////////////////////////////////////////////////////////////////////////

interface IRenderLoadMoreDenouncementsProps {
    item: FeedItemDto;
    onUpdateCard: (item: DeepPartial<FeedItemDto>) => void;
}

interface IRenderDenouncementsState {
    dialog: any;
    loading: boolean;
    lastError: any;
}

type RenderLoadMoreDenouncementsProps = IRenderLoadMoreDenouncementsProps & WithTranslation;

class RenderLoadMoreDenouncementsComponent extends React.Component<RenderLoadMoreDenouncementsProps, IRenderDenouncementsState>  {

    constructor(props: RenderLoadMoreDenouncementsProps) {
        super(props);
        this.state = {
            dialog: null,
            loading: false,
            lastError: null
        };
    }

    private handleOtherAbuseReports = () => {
        const { item, onUpdateCard } = this.props;

        this.setState({ loading: true });

        api.getOthersAbuseReport(item.action.actionId)
            .then((newData) => {

                item.action.otherReports = newData;

                this.setState(
                    { loading: false },
                    () => onUpdateCard(item)
                );
            })
            .catch((error) => {
                this.setState({ loading: false, lastError: error });
            });
    };


    public render() {
        const { item } = this.props;

        if (item.action.abuseReportCount < 2 || item.action.otherReports != null)
            return null;

        return (
            <MuiPushRight>
                <MuiRegularButton
                    onClick={this.handleOtherAbuseReports}
                    link
                >
                    <span>{this.props.t("Common.Feed.Literals.OtherReports")}</span>
                    <span>&nbsp;</span>
                    {this.state.loading && <SpinnerIndicator />}
                    {this.state.lastError && <MuiMessageBox variant="error" message={this.props.t("Common.Feed.Messages.CannotGetOtherReports")} />}
                </MuiRegularButton>
            </MuiPushRight>
        );
    }
}

export const RenderLoadMoreDenouncements = withTranslation()(RenderLoadMoreDenouncementsComponent);

/////////////////////////////////////////////////////////////////////////////////////

type RenderApprovalDrawerResult = {
    notes: string;
    approved: boolean;
};

interface IRenderApprovalDrawerProps {
    approvalText?: string;
    reprovalText?: string;
    disclaimer?: React.ReactNode;
    onClose: (result: RenderApprovalDrawerResult) => void;
}
interface IRenderApprovalDrawerState {
    notes: string;
}

type RenderApprovalDrawerProps = IRenderApprovalDrawerProps & WithTranslation;

class RenderApprovalDrawercomponent extends React.Component<RenderApprovalDrawerProps, IRenderApprovalDrawerState>
{
    constructor(props: RenderApprovalDrawerProps) {
        super(props);
        this.state = {
            notes: null,
        };
    }

    public render() {

        return (
            <BoxDrawer
                open
                title={this.props.t("Common.Feed.Approval.BoxTitle")}
                onClose={() => this.props.onClose(null)}
            >
                <MuiPaper dense elevation={0}>
                    <MuiContainer>
                        <TextFieldCounter
                            fullWidth
                            autoFocus
                            multiline
                            label={this.props.t<string>("Common.Feed.Approval.InputLabel")}
                            placeholder={this.props.t("Common.Feed.Approval.InputPlaceholder")}
                            maxLength={1500}
                            value={this.state.notes}
                            onChange={
                                (v) => {
                                    this.setState({ notes: v });
                                }
                            }
                        />
                    </MuiContainer>

                    <MuiContainer>
                        <Grid container xs={12} spacing={1} justifyContent="center">
                            <Grid item>
                                <ButtonApproval
                                    variant="outlined"
                                    size="small"
                                    justIcon={false}
                                    text={this.props.approvalText}
                                    onClick={() => { this.props.onClose({ notes: this.state.notes, approved: true }); }}
                                />
                            </Grid>
                            <Grid item>
                                <ButtonReproval
                                    variant="outlined"
                                    size="small"
                                    justIcon={false}
                                    text={this.props.reprovalText}
                                    onClick={() => { this.props.onClose({ notes: this.state.notes, approved: false }); }}
                                />
                            </Grid>
                        </Grid>
                    </MuiContainer>

                    {this.props.disclaimer}

                </MuiPaper>
            </BoxDrawer>
        );
    }
}

const RenderApprovalDrawer = withTranslation()(RenderApprovalDrawercomponent);

/////////////////////////////////////////////////////////////////////////////////////

interface IRenderAction {
    item: FeedItemDto;
    showBody: boolean;
    hasBody: boolean;
    onUpdateCard: (item: DeepPartial<FeedItemDto>) => void;
    onExpandText: (expanded: boolean) => void;
    onApprovalRequest: (actionId: string, approved: boolean, notes: string) => void;
}

interface IRenderActionState {
    dialog: any;
}

type RenderActionProps = IRenderAction & WithTranslation & StyledComponentProps<FeedClassKey>;

class RenderDenouncementActionComponent extends React.PureComponent<RenderActionProps, IRenderActionState>
{
    constructor(props: RenderActionProps) {
        super(props);
        this.state = {
            dialog: null,
        };
    }

    public render() {
        const {
            classes,
            item,
            showBody,
            hasBody,
            onExpandText,
            onUpdateCard,
            onApprovalRequest
        } = this.props;

        return (
            <>
                {this.state.dialog}

                <RenderDenouncements
                    classes={classes}
                    item={item}
                />


                <MuiContainer margin="none" flex={true}>
                    {
                        hasBody &&
                        <ButtonExpander
                            moreText={this.props.t("Common.Feed.Literals.ShowMoreText")}
                            lessText={this.props.t("Common.Feed.Literals.ShowLessText")}
                            expanded={showBody}
                            className={classes.expandButton}
                            onClick={
                                (textExpanded) => {
                                    onExpandText(textExpanded);
                                }
                            }
                        />
                    }

                    {
                        item.permissions.canApprove &&
                        <MuiPushRight>
                            <ApprovalButtons
                                classes={classes}
                                approvalText={this.props.t("Common.Feed.Approval.DenounceApprovalText")}
                                reprovalText={this.props.t("Common.Feed.Approval.DenounceReprovalText")}
                                onApproval={() => { onApprovalRequest(item.action.actionId, true, null); }}
                                onReproval={() => { onApprovalRequest(item.action.actionId, false, null); }}
                                onNotes={
                                    () => {
                                        this.setState({
                                            dialog: (
                                                <RenderApprovalDrawer
                                                    approvalText={this.props.t("Common.Feed.Approval.DenounceApprovalText")}
                                                    reprovalText={this.props.t("Common.Feed.Approval.DenounceReprovalText")}
                                                    disclaimer={
                                                        <MuiWell>
                                                            <Trans
                                                                i18nKey="Common.Feed.Approval.DenounceDisclaimer"
                                                                components={
                                                                    [
                                                                        <br />,
                                                                        <span style={{ color: "green", fontWeight: "bold" }}></span>,
                                                                        <span style={{ color: "red", fontWeight: "bold" }}></span>,
                                                                        <b></b>
                                                                    ]
                                                                }
                                                            />
                                                        </MuiWell>
                                                    }
                                                    onClose={(result: RenderApprovalDrawerResult) => {
                                                        if (result != null) {
                                                            if (result.approved) onApprovalRequest(item.action.actionId, true, result.notes);
                                                            else onApprovalRequest(item.action.actionId, false, result.notes);
                                                        }
                                                        this.setState({ dialog: null });
                                                    }}
                                                />
                                            )
                                        });
                                    }
                                }
                            />
                        </MuiPushRight>
                    }

                    <RenderLoadMoreDenouncements
                        {...this.props}
                        item={item}
                        onUpdateCard={onUpdateCard}
                    />

                </MuiContainer>
            </>
        );
    }
}

export const RenderDenouncementAction = withTranslation()(RenderDenouncementActionComponent);

/////////////////////////////////////////////////////////////////////////////////////

class RenderDefaultApprovalActionComponent extends React.PureComponent<RenderActionProps, IRenderActionState>
{
    constructor(props: RenderActionProps) {
        super(props);
        this.state = {
            dialog: null,
        };
    }

    public render() {
        const {
            classes,
            item,
            showBody,
            hasBody,
            onExpandText,
            onApprovalRequest
        } = this.props;

        return (
            <>
                {this.state.dialog}

                <MuiContainer margin="dense">
                    <ActionRequesterBody
                        classes={classes}
                        data={item}
                    />
                </MuiContainer>

                <RenderAutoModerationReason
                    classes={classes}
                    item={item}
                />

                <MuiContainer margin="none" flex={true}>
                    {
                        hasBody &&
                        <ButtonExpander
                            moreText={this.props.t("Common.Feed.Literals.ShowMoreText")}
                            lessText={this.props.t("Common.Feed.Literals.ShowLessText")}
                            expanded={showBody}
                            className={classes.expandButton}
                            onClick={
                                (textExpanded) => {
                                    onExpandText(textExpanded);
                                }
                            }
                        />
                    }
                    <MuiPushRight>
                        <ApprovalButtons
                            classes={classes}
                            onApproval={() => { onApprovalRequest(item.action.actionId, true, null); }}
                            onReproval={() => { onApprovalRequest(item.action.actionId, false, null); }}
                            onNotes={
                                () => {
                                    this.setState({
                                        dialog: (
                                            <RenderApprovalDrawer
                                                onClose={(result: RenderApprovalDrawerResult) => {
                                                    if (result != null) {
                                                        if (result.approved) onApprovalRequest(item.action.actionId, true, result.notes);
                                                        else onApprovalRequest(item.action.actionId, false, result.notes);
                                                    }
                                                    this.setState({ dialog: null });
                                                }}
                                            />
                                        )
                                    });
                                }
                            }

                        />
                    </MuiPushRight>

                </MuiContainer>
            </>
        );
    }
}

export const RenderDefaultApprovalAction = withTranslation()(RenderDefaultApprovalActionComponent);

/////////////////////////////////////////////////////////////////////////////////////

interface IRenderDefaultActions {
    item: FeedItemDto;
    feedType: FeedType;
    fullView: boolean;
    showRelationsButton: boolean;
    onEdit: () => void;
    onDelete: () => void;
    onInfoRequest?: () => void;
    onSidebarResetRequest?: () => void;
    onUpdateCard: (item: DeepPartial<FeedItemDto>) => void;
    onReloadPublication: () => Promise<void>;
}

export const RenderDefaultActions: React.FC<IRenderDefaultActions & StyledComponentProps<FeedClassKey>> = (props) => {

    const {
        classes,
        item,
        feedType,
        fullView,
        showRelationsButton,
        onInfoRequest,
        onSidebarResetRequest,
        onReloadPublication,
        onUpdateCard,
        onEdit,
        onDelete
    } = props;

    return (
        <Grid container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
        >
            <Grid item>
                <ActionsSocial
                    data={item}
                    fullView={fullView}
                    showCommentsButton={!fullView}
                    onUpdateCard={onUpdateCard}
                />
            </Grid>
            <Grid item>
                <ActionsDefaultRight
                    classes={classes}
                    data={item}
                    fullView={fullView}
                    showAddToFavorites
                    showShareButton
                    showRelationsButton={showRelationsButton}
                    onUpdateCard={onUpdateCard}
                    onSidebarResetRequest={onSidebarResetRequest}
                />
                <ActionsDefaultDropDown
                    classes={classes}
                    data={item}
                    feedType={feedType}
                    fullView={fullView}
                    onInfoRequest={onInfoRequest}
                    onEditPublication={onEdit}
                    onRemovePublication={onDelete}
                    onReloadPublication={onReloadPublication}
                    onUpdateCard={onUpdateCard}
                />
            </Grid>
        </Grid>
    );
};

/////////////////////////////////////////////////////////////////////////////////////

export const RenderPollActions: React.FC<IRenderDefaultActions & StyledComponentProps<FeedClassKey>> = (props) => {

    const {
        classes,
        item,
        fullView,
        showRelationsButton,
        onSidebarResetRequest,
        onUpdateCard,
        onEdit,
        onDelete
    } = props;

    return (
        <CardActions className={classes.cardActions} >

            <Grid container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <Grid item>
                    <ActionsSocial
                        data={item}
                        fullView={fullView}
                        showCommentsButton={!fullView}
                        onUpdateCard={onUpdateCard}
                    />
                </Grid>
                <Grid item>
                    <ActionsDefaultRight
                        classes={classes}
                        data={item}
                        fullView={fullView}
                        showAddToFavorites
                        showShareButton
                        showRelationsButton={showRelationsButton}
                        onUpdateCard={onUpdateCard}
                        onSidebarResetRequest={onSidebarResetRequest}
                    />
                    <ActionsPollDropDown
                        classes={classes}
                        data={item}
                        onEditPublication={onEdit}
                        onRemovePublication={onDelete}
                        onUpdateCard={onUpdateCard}
                    />
                </Grid>
            </Grid>
        </CardActions>
    );
};

/////////////////////////////////////////////////////////////////////////////////////
